import * as React from 'react';

function SvgLogoXOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M2.108 2.696l7.676 10.263-7.725 8.345h1.739l6.763-7.306 5.464 7.306h5.916l-8.108-10.84 7.19-7.768h-1.739l-6.228 6.728-5.032-6.728H2.108zm2.556 1.28h2.718l12.002 16.048h-2.718L4.664 3.976z" })));
}

export default SvgLogoXOutline;
